import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-status-badge',
    templateUrl: './status-badge.component.html',
    styleUrls: ['./status-badge.component.css'],
    standalone: false
})
export class StatusBadgeComponent implements OnInit {

@Input() status: string = '';
@Input() availableStatuses: AvailableBadgeStatus[] = [];

  currentStatus: AvailableBadgeStatus | undefined;

  ngOnInit(): void {
    this.currentStatus = this.getStatusBadge(this.status);
  }

  getStatusBadge(status: string): AvailableBadgeStatus | undefined {
    return this.availableStatuses.find(s => s.value === status);
  }
}

export interface AvailableBadgeStatus {
  value: string;
  label: string;
  color: string;
}